import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { MasterManagementService } from '../../../../../management/master-management/master-management.service';
import { CommonService } from '../../../../../../shared/services/common.service';



@Component({
  selector: 'app-excursion',
  templateUrl: './excursion.component.html',
  styleUrls: ['./excursion.component.css']
})
export class ExcursionComponent implements OnInit {
  public excursionsList: any[] = [];

  customer_id: string;

  isFormModalVisible: boolean = false;
  isLoading: boolean = false;
  isEditMode: boolean = false;
  editingExcursionId: number | null = null;

  listOfColumns = [
    { name: 'Excursion Id' },
    { name: 'Excursion Reason' },
    { name: 'Action' }
  ]

  excursionForm!: FormGroup;
  excursionOptions: any[] = [];


  constructor(
    public masterManagementService: MasterManagementService,
    public commonService: CommonService,
    private fb: FormBuilder,
    public route: ActivatedRoute
  ) {
    this.customer_id = this.route.snapshot.params['id'];
  }

  ngOnInit() {
    this.getExcursions();
    this.initializeForm();
  }

  openFormModal(): void {
    this.isEditMode = false;
    this.editingExcursionId = null;
    this.excursionForm.reset();
    this.isFormModalVisible = true;
    this.getExcursionOptions();
  }

  openEditModal(excursion: any): void {
    this.isEditMode = true;
    this.editingExcursionId = excursion.reason_id ?? null;
    this.excursionForm.patchValue({
      reason_of_exceursion: excursion.reason_of_exceursion
    });
    this.isFormModalVisible = true;
  }

  initializeForm(): void {
    this.excursionForm = this.fb.group({
      reason_of_exceursion: ['', Validators.required],
    });
  }
  getExcursions() {
    this.isLoading = true;
    const payload = {
      customer_id: this.customer_id
    }
    this.masterManagementService.getExcursionsByCustomerId(payload).subscribe((res: any) => {
      if (res.status === 200) {
        this.excursionsList = (res.data || []).map((item: any, idx: number) => {
          const reasonId = item?.reason_id ?? item?.id ?? null;
          const normalizedId = reasonId ?? -(idx + 1);
          return {
            ...item,
            reason_id: reasonId ?? normalizedId,
          };
        });
        console.log(this.excursionsList);
      }
      this.isLoading = false;
    }, (err: any) => {
      this.isLoading = false;
      console.error(err);
    });
  }
  getExcursionOptions() {
    if (this.excursionOptions.length > 0) return;

    this.isLoading = true;
    const payload = {
      customer_id: -1
    }
    this.masterManagementService.getExcursionsByCustomerId(payload).subscribe((res: any) => {
      if (res.status === 200) {
        this.excursionOptions = res?.data;
      }
      this.isLoading = false;
    }, (err: any) => {
      this.isLoading = false;
      console.error(err);
    });
  }
  deleteExcursion(id: number): void {
    this.isLoading = true;
    this.masterManagementService.deleteExcursion(id).subscribe({
      next: (res: any) => {
        if (res.status === 200) {
          this.getExcursions();
          this.commonService.message.success('Excursion deleted successfully');
        } else {
          this.commonService.message.error(res?.message || 'Failed to delete excursion');
        }
      },
      error: (err: any) => {
        console.error(err);
        this.commonService.message.error('Failed to delete excursion');
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }
  submitForm(): void {
    if (this.excursionForm.valid) {
      if (this.isEditMode && this.editingExcursionId) {
        const payload = {
          reason_of_exceursion: this.excursionForm.value.reason_of_exceursion
        };
        this.isLoading = true;
        this.masterManagementService.updateExcursion(this.editingExcursionId, payload).subscribe({
          next: (res: any) => {
            if (res.status === 200) {
              this.getExcursions();
              this.isFormModalVisible = false;
              this.excursionForm.reset();
              this.isEditMode = false;
              this.editingExcursionId = null;
              this.commonService.message.success('Excursion updated successfully');
            }
            this.isLoading = false;
          },
          error: (err: any) => {
            this.isLoading = false;
            this.commonService.message.error('Failed to update excursion');
          }
        });
      } else {
        const payload = {
          reason_of_exceursion: this.excursionForm.value.reason_of_exceursion,
          customer_id: this.customer_id
        };
        this.masterManagementService.addExcursion(payload).subscribe((res: any) => {
          if (res.status === 200) {
            this.getExcursions();
            this.isFormModalVisible = false;
            this.excursionForm.reset();
            this.commonService.message.success('Excursion added successfully');
          }
        });
      }
    }
  }
}
